import React from 'react';
import './ThankYou.css';

const ThankYou: React.FC = () => {
  const handleHomeClick = () => {
    window.location.href = 'https://www.sdevelop.com/';
  };

  return (
    <div className="thank-you-container">
      <div className="thank-you-card">
        <div className="success-icon">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        <h1>Thank You!</h1>
        <h2>Your Application Has Been Submitted Successfully</h2>
        <p className="thank-you-message">
          We appreciate your interest in joining our team. Your application has been 
          received and is now under review by our hiring team.
        </p>
        <div className="next-steps">
          <h3>What Happens Next?</h3>
          <ul>
            <li>Our HR team will review your application carefully</li>
            <li>If your qualifications match our requirements, we'll contact you for an interview</li>
          </ul>
        </div>
        <div className="contact-info">
          <p>
            If you have any questions, feel free to contact our HR department.
          </p>
        </div>
        <button 
          className="btn btn-primary home-button"
          onClick={handleHomeClick}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
